import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';

@Injectable({
  providedIn: 'any',
})
export class QueryParticipantPlanningsGQL extends Query<Response> {
  document = gql`
    query ParticipantPlanning($id: ID!) {
      participantPlanning(id: $id) {
        id
        type {
          label
          color
          colorLabel
        }
        content
        createAt
        dateStart
        referent {
          avatar
          displayName
          fonction
          setting {
            color
          }
        }
        auteur {
          avatar
          fonction
          displayName
          setting {
            color
          }
        }
      }
    }
  `;
}
